import AdvertiserRepository from './advertiserRepository'
import ProfileRepository from './profileRepository'
import StoreRepository from './storeRepository'
import UserRepository from './userRepository'

const repositories = {
  store: StoreRepository,
  user: UserRepository,
  advertiser: AdvertiserRepository,
  profile: ProfileRepository,
}

export const RepositoryFactory = {
  get: (name) => repositories[name],
}
